import React from 'react';
import PopupState, {bindTrigger, bindPopover} from 'material-ui-popup-state';
import {IconButton, makeStyles, Popover} from '@material-ui/core';
import {LinkOff} from '@material-ui/icons';
import {Button, ButtonClass} from '@treez-ui/core/buttons';

interface Props {
    onSubmit: () => void;
    value: string;
}

export const ClearOverridePopover = (props: Props) => {
    const {value, onSubmit} = props;

    const useStyles = makeStyles({
        overridePopupContentContainer: {
            padding: '24px',
            width: '240px',
        },
        overridePopupContentTitle: {
            fontSize: '20px',
            margin: '12px 0',
            textAlign: 'center',
        },
        overridePopupText: {
            margin: '12px 0',
            textAlign: 'center',
        },
        overridePopupButtonContainer: {
            display: 'grid',
            gridColumnGap: '12px',
            gridTemplateColumns: 'repeat(2, 1fr)',
            marginTop: '24px',
        },
    });

    const {
        overridePopupContentContainer,
        overridePopupContentTitle,
        overridePopupText,
        overridePopupButtonContainer,
    } = useStyles();

    return (
        <PopupState variant="popover" popupId="clear-override-popover">
            {(popupState) => (
                <div>
                    <IconButton
                        {...bindTrigger(popupState)}
                        onMouseDown={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                        }}
                    >
                        <LinkOff />
                    </IconButton>
                    <Popover
                        {...bindPopover(popupState)}
                        anchorOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                        transformOrigin={{
                            vertical: 'top',
                            horizontal: 'center',
                        }}
                    >
                        <div className={overridePopupContentContainer}>
                            <div className={overridePopupContentTitle}>Reset To</div>
                            <div className={overridePopupText}>{value || `'No Value'`}</div>
                            <div className={overridePopupButtonContainer}>
                                <Button
                                    buttonClass={ButtonClass.QUIET}
                                    text="Cancel"
                                    onClick={popupState.close}
                                />
                                <Button
                                    buttonClass={ButtonClass.BASIC}
                                    text="OK"
                                    onClick={() => {
                                        onSubmit();
                                        popupState.close();
                                    }}
                                />
                            </div>
                        </div>
                    </Popover>
                </div>
            )}
        </PopupState>
    );
};
